import { CenteredCard } from 'components'

const SignIn = () => {
  return (
    <CenteredCard />
  )
}

export default SignIn